import { Skeleton } from '@/components/ui/Skeleton.tsx';
import React from 'react';

const TourOptionsFormSkeleton = () => {
  return (
    <div>
      <div className="mb-6 animate-pulse space-y-2 pt-2">
        <Skeleton className="h-[32px] w-full max-w-[280px]" />
        <div className="grid grid-cols-2 gap-1">
          <Skeleton className="h-[100px] w-full" />
        </div>
      </div>
      <div className="mb-6 animate-pulse space-y-2 pt-2">
        <Skeleton className="h-[32px] w-full max-w-[280px]" />
        <div className="grid grid-cols-2 gap-1">
          <Skeleton className="h-[100px] w-full" />
          <Skeleton className="h-[100px] w-full" />
          <Skeleton className="h-[100px] w-full" />
        </div>
      </div>
    </div>
  );
};

export default TourOptionsFormSkeleton;
